import {MutableRefObject, useEffect} from 'react';

type TransitionEvent = 'transitionrun' | 'transitionstart' | 'transitioncancel' | 'transitionend'

const useTransitionEvent = (
	event: TransitionEvent,
	ref: MutableRefObject<HTMLElement>,
	onEvent: () => void,
	preventPropagationFromChild: boolean = false,
) => {
	const handleTransitionEvent = (event) => {
		if (preventPropagationFromChild && ref.current !== event.target) {
			return;
		}

		onEvent();
	};

	useEffect(() => {
		const el = ref.current;

		el?.addEventListener(
			event,
			handleTransitionEvent,
			preventPropagationFromChild ? false : undefined
		);

		return () => el?.removeEventListener(event, handleTransitionEvent);
	}, []);
};

export default useTransitionEvent;
